function newsletterForm() {
  document.querySelectorAll('form.newsletter-form').forEach((newsletter) => {
    if (newsletter) {
      newsletter.setAttribute('novalidate', 'novalidate')
    }
    const emailInput = newsletter.querySelector('input[type="email"]')
    const errorDiv = newsletter.querySelector('.email-error')

    function validateEmail() {
      const value = emailInput.value.trim()
      errorDiv.textContent = ''
      emailInput.classList.remove('invalid')
      errorDiv.classList.remove('active')

      if (!value) {
        errorDiv.textContent = 'Please complete this required field.'
        emailInput.classList.add('invalid')
        errorDiv.classList.add('active')
        return false
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailPattern.test(value)) {
        errorDiv.textContent = 'Email must be formatted correctly.'
        emailInput.classList.add('invalid')
        errorDiv.classList.add('active')
        return false
      }

      return true
    }

    // Debounce function
    function debounce(func, delay) {
      let timeoutId
      return function (...args) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => func.apply(this, args), delay)
      }
    }

    const debouncedValidate = debounce(validateEmail, 700)

    emailInput.addEventListener('blur', validateEmail)

    // Validate on input (typing) with debounce
    emailInput.addEventListener('input', debouncedValidate)

    newsletter.addEventListener('submit', function (e) {
      e.preventDefault()
      if (validateEmail()) {
        // Submit form or show success
        this.submit()
      }
    })
  })
}

export default newsletterForm
